import gql from 'graphql-tag';

import { VideoDetails } from '../fragments/video';
import { CommentDetails } from '../fragments/comments';
import {
  AccountFileReactionDetails,
  GroupedReactionsDetails,
  ReactionAccountDetails,
} from '../fragments/reactions';

export const Video = gql`
  query video($id: RecordID!) {
    video(id: $id) {
      id
      ...VideoDetails
    }
  }
  ${VideoDetails}
`;

export const VideoDownloadLink = gql`
  query videoDownloadLinks($id: RecordID!) {
    videoDownloadLinks(id: $id) {
      url
      quality
      type
      fps
      filesize
      filesize_short
      width
      height
    }
  }
`;

export const VideoForCommentsAndReactions = gql`
  query videoForCommentsAndReactions(
    $id: RecordID!
    $comments_limit: Int = 20
    $comments_offset: Int = 0
    $account_reactions_limit: Int = 20
    $account_reactions_offset: Int = 0
    $parent_id: RecordID
    $root_only: Boolean
  ) {
    video(id: $id) {
      id
      is_owner
      is_uploader
      comments(
        slice: { limit: $comments_limit, offset: $comments_offset }
        parent_id: $parent_id
        root_only: $root_only
      ) {
        total
        records {
          id
          ...CommentDetails
        }
      }
      grouped_reactions(slice: { limit: 999 }) {
        total
        records {
          id
          ...GroupedReactionsDetails
        }
      }
      account_file_reaction {
        ...AccountFileReactionDetails
      }
      reactions_accounts(
        slice: {
          limit: $account_reactions_limit
          offset: $account_reactions_offset
        }
      ) {
        total
        records {
          ...ReactionAccountDetails
        }
      }
    }
  }
  ${CommentDetails}
  ${GroupedReactionsDetails}
  ${AccountFileReactionDetails}
  ${ReactionAccountDetails}
`;
